<div class="content">
  <div *ngIf="poi == null">
    <h3 class="loading">Inhalt wird geladen...</h3>
  </div>

  <div *ngIf="poi != null">
    <h1>{{ poi.name }}</h1>

    <div *ngIf="imageObjects.length > 0" class="image-slider" [style.maxWidth.px]= "numberOfShownImages * 305">
    <ng-image-slider [images]="imageObjects" [imageSize]="{ width: '300px', height: '400px', space: '5'}" [autoSlide]="{interval: showArrows() ? 5 : 0, stopOnHover: true}" [infinite]="true" [manageImageRatio]="true" [ngClass]="{'shown' : showImages}" [showArrow]="showArrows()" #slider></ng-image-slider>
    </div>

    <p class="text">{{ poi.detailDescription || poi.description }}</p>

    <div *ngIf="poi.link" class="link">
      Webseite: <a href="{{getUrl()}}" rel="nofollow" target="_blank">{{getUrl(true)}}</a>
    </div>

    <div class="tags" *ngIf="poi.tags != ''">
      <div class="tag" *ngFor="let tag of poi.tags.split(',')">
        {{tag}}
      </div>
    </div>

    <div class="map">
      <app-map [lat]="poi.lat" [lon]="poi.lon" [name]="poi.name"></app-map>
    </div>

    <div class="ratings">
      <app-poi-rating [poiId]="poi.id"></app-poi-rating>
    </div>

    <div class="meta">
      <p>Kategorie: <a [routerLink]="['/', getCategoryUrl()]" >{{ getCategoryName() | titlecase }}</a></p>
      <p>Gemeinde: <a [routerLink]="['/gemeinde/', getMunicipalityUrl()]" >{{ poi.municipality | titlecase }}</a></p>
    </div>

  </div>
</div>

